import { Button } from '@douyinfe/semi-ui';
import styled from '@jupiter/plugin-runtime/styled';
import { ReactNode } from 'react';
import { useUserInfo } from '@/hooks/useUserInfo';

interface Props {
  children: ReactNode;
}
const Wrapper = styled.div`
  position: relative;
`;

const Blur = styled(
  ({ blur, ...rest }: { blur: boolean; children: ReactNode }) => (
    <div {...rest} />
  ),
)`
  position: relative;
  filter: ${props => (props.blur ? 'blur(2px)' : 'none')};
`;

const Mask = styled.div`
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const LoginMask = ({ children }: Props) => {
  // const { info: userInfoFromRoot } = StoreInfoModel.useContext();

  // const notLogin = !userInfoFromRoot;

  const { ifLogin } = useUserInfo();

  return (
    <Wrapper>
      <Blur blur={!ifLogin}>{children}</Blur>
      {!ifLogin && (
        <Mask
          onClick={() => {
            if (window.Garfish) {
              window.Garfish.channel.emit('main:login-activate');
            }
          }}>
          <Button type="primary" size="large" theme={'solid'}>
            登录后才能发帖
          </Button>
        </Mask>
      )}
    </Wrapper>
  );
};
